import {combineReducers} from 'redux';
import quickPanel from './quickPanel.reducer';

const reducer = combineReducers({
  quickPanel,
});

export default reducer;
